/**
 * @deprecated Quarantined legacy. Don't add new consumers.
 *
 * Moved out of the Angular tree in WEB-8484 so the ReactTemplates.findProspect global could survive
 * Phase 6. WEB-9203 converted every reader to import these directly and removed the global, so the
 * subtree now loads through its imports rather than a side-effect barrel.
 */
'use strict';

const StartInfo = window.ReactCreateClass({
	getInitialState: function () {
		return {};
	},
	render: function () {
		var self = this;
		return (
			<div id="find-prospects-body">
				<div id="start-info-main">
					<div id="start-img">
						<img src="img/find-new-prospects.png" />
					</div>
					<h2 className="start-info-title">{self.props.infoTitle}</h2>
					<div id="start-info-text">{self.props.infoText}</div>
				</div>
			</div>
		);
	}
});

export { StartInfo as startInfo };
